export const SOURCE_STATUSES = {
  UPCOMING: "UPCOMING",
  ACTIVE: "ACTIVE",
  ENDED: "ENDED",
  STOPPED: "STOPPED",
};
